import React from "react";
import { Box, Typography, TextField } from "@mui/material";
import fieldTemplatesStyles from "../../Settings/FieldTemplatesSettings/FieldTemplatesStyles";

export default function EditDetailsTab({ formData, setFormData, trackableName }) {
  const classes = fieldTemplatesStyles();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <Box>
        <Typography sx={{ mb: 1 }}>Page Name*</Typography>
        <Box className={classes.cardContentDiv3}>
          <TextField
            placeholder="Enter page name here"
            value={formData.pageName}
            onChange={(e) =>
              setFormData({ ...formData, pageName: e.target.value })
            }
            sx={{
              "& .MuiInputBase-input": {
                padding: "6px",
                backgroundColor: "transparent",
                color: "white !important",
                opacity: 1,
                fontSize: "16px",
                fontFamily: "poppins",
              },
              "& .MuiOutlinedInput-root": {
                borderRadius: "4px",
                "& fieldset": {
                  borderColor: "transparent",
                },
                "&:hover fieldset": {
                  borderColor: "transparent",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "transparent",
                },
              },
            }}
            fullWidth
          />
        </Box>
      </Box>

      <Box>
        <Typography sx={{ mb: 1 }}>Description</Typography>
        <Box className={classes.cardContentDiv3}>
          <TextField
            placeholder="Enter a description"
            value={formData.description}
            onChange={(e) =>
              setFormData({ ...formData, description: e.target.value })
            }
            sx={{
              "& .MuiInputBase-input": {
                padding: "6px",
                backgroundColor: "transparent",
                color: "white !important",
                opacity: 1,
                fontSize: "16px",
                fontFamily: "poppins",
              },
              "& .MuiOutlinedInput-root": {
                borderRadius: "4px",
                "& fieldset": {
                  borderColor: "transparent",
                },
                "&:hover fieldset": {
                  borderColor: "transparent",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "transparent",
                },
              },
            }}
            fullWidth
          />
        </Box>
      </Box>

      <Box>
        <Typography sx={{ mb: 1, color: "rgba(255,255,255,0.7)" }}>
          Trackable Type
        </Typography>
        <Box
          sx={{
            backgroundColor: "#252A38",
            borderRadius: "10px",
            p: 2,
            border: "1px solid #606479",
          }}
        >
          <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
            {trackableName || "Not specified"}
          </Typography>
          <Typography
            sx={{
              fontSize: "12px",
              color: "rgba(255,255,255,0.6)",
              mt: 0.5,
            }}
          >
            Trackable type cannot be changed after creation
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
